var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 0
    ? _c("div", { staticClass: "intl-pagination" }, [
        _c("div", { staticClass: "intl-pagination__nav" }, [
          _c(
            "button",
            {
              attrs: {
                type: "button",
                disabled: _vm.page <= 1,
                "aria-label": "previous",
              },
              on: {
                click: function ($event) {
                  return _vm.go(_vm.page - 1)
                },
              },
            },
            [_vm._v("←")]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.totalPages)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: {
                type: "button",
                disabled: _vm.page >= _vm.totalPages,
                "aria-label": "next",
              },
              on: {
                click: function ($event) {
                  return _vm.go(_vm.page + 1)
                },
              },
            },
            [_vm._v("→")]
          ),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "intl-pagination__size" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("common.perPage")))]),
          _vm._v(" "),
          _c(
            "select",
            {
              domProps: { value: _vm.size },
              on: {
                change: function ($event) {
                  return _vm.changeSize($event.target.value)
                },
              },
            },
            _vm._l(_vm.pageSizes, function (option) {
              return _c(
                "option",
                { key: option, domProps: { value: option } },
                [_vm._v(_vm._s(option))]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }